<template>
  <div @click="$emit('action')" class="action-bar-container">
    <v-icon
      v-for="(action, index) in actions"
      :key="action.icon + index"
      class="action-bar-icon"
      @click="() => action.action()"
      :style="{ color: primaryColor }"
    >
      {{ action.icon }}
    </v-icon>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { GalleryThumbnailAction } from "features/gallery/thumbnail/GalleryThumbnail.vue"
import Theme from "constants/theme"

export default defineComponent({
  name: "GalleryThumbnailActionBar",
  props: {
    actions: {
      type: Array as PropType<GalleryThumbnailAction[]>,
      default: () => [],
    },
  },
  setup() {
    return {
      primaryColor: Theme.colors.light.primary,
    }
  },
})
</script>

<style scoped>
.action-bar-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  height: 28px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.8);
  padding: 4px;
}

.action-bar-icon {
  margin-left: 8px;
}
</style>
